<template>
  <div class="header">
    <router-link class="header__previous" type='button'
      :to='{name: previousRouteName}'
      v-if='previous'>
        <Icon icon='chevron-left'/>
        <span>{{ previous }}</span>
    </router-link>
    <div class="header__title">
      {{ title }}
    </div>
    <button class="header__account" 
      type="button" 
      @click="toggleMenu($event)" 
      v-show='showAccountControl'>
      <Icon icon='account-circle'/>
    </button>
    <button id='a2hs' class='header__a2hs' 
      style='display: none' type='button'>
      <Icon icon='open-in-app'/>
    </button>
    <div class="header__account-menu" v-show='showMenu'>
      <button type='button' @click='logout'>ログアウト</button>
      <button type='button' @click='appReload'>アプリ再読込</button>
      <label>Ver:<span class="js-api-version">0.0</span></label>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      showMenu: false,
      previous: '',
      previousRouteName: '',
      title: '',
      showAccountControl: true
    }
  },
  methods: {
    update: function(params) {
      if (params.title !== undefined)
        this.title = params.title

      if (params.previous !== undefined)
        this.previous = params.previous
      
      if (params.previousRouteName !== undefined)
        this.previousRouteName = params.previousRouteName

      if (params.showAccountControl !== undefined)
        this.showAccountControl = params.showAccountControl
    },
    toggleMenu: function($event) {
      this.showMenu = !this.showMenu;
      document.getElementsByClassName('js-api-version')[0].textContent = window.current_api_version;
      $event.stopPropagation();
    },
    logout: function() {
      // let token = localStorage.getItem('access_token');
      this.$api.removeToken();
      this.$router.push('/login');
      // this.$api.logout(token);
    },
    appReload: function() {
      this.$$.alert({
        message: 'アプリケーションを再読込します。',
        actionText: '再読込',
        cancelText: 'キャンセル',
        action: () => {
          navigator.serviceWorker.getRegistration()
                  .then(registration => {
                    registration.unregister();
                  })
          setTimeout(window.location.reload(), 1000);
        },
        cancelAction: () => {
        }
      })
    }
  },
  created: function() {
    document.body.addEventListener(
      'click', 
      ()=> this.showMenu = false
    )
    this.$$.context = this.update.bind(this)
  }
}
</script>

<style lang='scss'>
.header {
  height: 56px;
  background: #f5f5f5;
  display: block;
  font-size: 16px;
  .icon {
    font-size: 1.5em;
    vertical-align: -.25em;
    svg path {fill: #36f;}
  }
  &__title {
    position: absolute;
    top: 14px;
    font-size: 1.25em;
    left: 50%;
    transform: translateX(-50%);
  }
  &__previous,
  &__account,
  &__a2hs {
    line-height: 56px;
    padding: 0 .5em;
    height: 56px;
    white-space: nowrap;
    text-align: center;
    outline: none;
    color: #3366ff;
    font-size: 1.125em;
    text-decoration: none;
  }
  &__previous {
    float: left;
  }
  &__account {
    float: right;
  }
  &__a2hs {
    float: right;
  }
  &__account-menu {
    color: #333;
    position: absolute;
    right: 0;
    top: calc(100% + 1px);
    padding: 4px 0;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    white-space: nowrap;
    background: #fff;
    label {
      background: #333333;
      color: #ffffff;
      border: none;
      display: block;
      line-height: 24px;
      font-size: 10px;
      font-weight: bold;
      padding: 0 12px;
      outline: none;
      text-align: right;
    }
    button {
      background: none;
      border: none;
      display: block;
      line-height: 32px;
      font-size: 14px;
      padding: 0 12px;
      outline: none;
    }
  }
}
  
</style>